//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavAgents(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 3H7.5V7.5H3V3Z" fill="currentColor" /><path d="M16.5001 3H21.0001V7.5H16.5004V16.4999H7.50044L7.5 7.5H16.5004L16.5001 3Z" fill="currentColor" /><path d="M21.0001 16.5001L16.5004 16.4999L16.5001 21.0001H21.0001V16.5001Z" fill="currentColor" /><path d="M3 16.5001L7.50044 16.4999L7.5 21.0001H3V16.5001Z" fill="currentColor" /></svg>;
}
export default IconNavAgents;